import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'lib-lib-trend-core',
    imports: [],
    template: `
    <p>
      lib-trend-core works!
    </p>
  `,
    changeDetection: ChangeDetectionStrategy.Eager,
    styles: ``
})
export class LibTrendCoreComponent {

}
